import React from 'react'

import { array } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AccordionItem from './AccordionItem'

function Accordion({ items = EMPTY_ARRAY }) {
  if (!items?.length) {
    return null
  }

  return (
    <ul className="accordion">
      {items.map((item, index) => (
        <AccordionItem key={`accordion-item-${index}`} {...item} />
      ))}
    </ul>
  )
}

Accordion.propTypes = {
  items: array,
}

export default Accordion
